import React from 'react';
import PropTypes from 'prop-types';

function Avatar({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M9.333 15.5v.557c0 .66-.333 1.717-3.666 2.31a4.482 4.482 0 00-2.42 1.236A4.41 4.41 0 002 22h20a5.11 5.11 0 00-1.48-2.378A5.185 5.185 0 0018 18.368c-3.333-.627-3.333-1.651-3.333-2.311V15.5"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M17 10.305C17 13.4 14.75 16 12 16s-5-2.476-5-5.571V7.457C7 4.238 9.643 3 12 3s5 1.114 5 4.333v2.972z"
      />
    </svg>
  );
}

Avatar.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Avatar;
